import {MarginLevel} from "../models/MarginLevel";

export const MarginLevelFilter = "marginLevel";

export function marginLevelFilter() {
    return (input: MarginLevel) => {
        switch (input) {
            case MarginLevel.LEVEL_1:
                return "1";
            case MarginLevel.LEVEL_2:
                return "2";
            case MarginLevel.LEVEL_3:
                return "3";
            case MarginLevel.LEVEL_4:
                return "4";
            default:
                return input;
        }
    };
}
